export const Svg_108 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M32.57 24.306V13.61H20.904V8.75h28.194v4.861H37.432v10.695H32.57ZM11.668 61.25V38.403h4.86v2.916h10.21v-9.722H23.82v-4.86h22.361v4.86h-2.916v9.722h10.208v-2.916h4.861V61.25h-4.86v-2.917H16.528v2.917h-4.861Zm4.86-7.778h36.945v-7.291h-15.07V31.597h-6.805v14.584h-15.07v7.291Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.459}
        x2={48.596}
        y1={16.625}
        y2={54.225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)